module.exports = __webpack_public_path__ + "static/media/sum_created_plan.c423f4cb.png";